import React, { useContext } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button } from '@jutro/components';
import { TranslatorContext } from '@jutro/locale';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import metadata from './SpmVehicleModificationsTable.metadata.json5';

function SpmVehicleModificationsTable(props) {
    const translator = useContext(TranslatorContext);
    const {
        displayedModifications,
        disableEditButton,
        editModification,
        removeModification
    } = props;

    const getCellValue = (item, index, { id: property }) => {
        if (!_.isNil(item[property].value)) {
            const displayName = {
                id: item[property].value.name,
                defaultMessage: item[property].value.name
            };
            return translator(displayName);
        }

        return null;
    };

    const getModificationButtons = (item, index) => {
        const onClickEdit = () => {
            editModification(index);
        };

        const onClickRemove = () => {
            removeModification(index);
        };

        return (
            <span>
                <Button id="editModificationButton" disabled={disableEditButton} onClick={onClickEdit} className="sgSecondaryWhiteButton">
                    Edit
                </Button>
                <Button id="removeModificationButton" disabled={disableEditButton} onClick={onClickRemove} className="sgSecondaryWhiteButton">
                    Remove
                </Button>
            </span>

        );
    };

    const overrides = {
        vehicleModificationsTable: {
            data: displayedModifications,
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            getCellValue: getCellValue,
            getModificationButtons: getModificationButtons
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

SpmVehicleModificationsTable.propTypes = {
    disableEditButton: PropTypes.bool.isRequired,
    editModification: PropTypes.func.isRequired,
    removeModification: PropTypes.func.isRequired,
    displayedModifications: PropTypes.shape([]).isRequired
};

export default SpmVehicleModificationsTable;
